import React from "react";
import adBanner from "asset/images/ads/usdkshAd.png";

export default function KESUSDRightMock() {
    return (
        <img
            src={adBanner}
            alt="USDC promo"
            className="w-full h-36 object-cover rounded-md"
            loading="lazy"
            decoding="async"
        />
    );
}
